import React, { useState, useEffect, useRef } from 'react'
import { connect } from 'react-redux';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';


const ClicksInGrid = ( { clicks, links } ) => {
    const [ count, setCount ] = useState( clicks || 0 );
    const [ urls, setUrls ] = useState( [] );
    const [show, setShow] = useState(false);
    const handleOnMouseEnter = () => {
        setShow( true );
    }
    const handleOnMouseLeave = () => {
        setShow( false );
    }

    const ref = useRef();

    const popup = (
        <Popover id="popover-basic" style={ { width: '100%', zIndex: '9999' } } onMouseEnter={handleOnMouseEnter} onMouseLeave={handleOnMouseLeave}>
            <Popover.Header as="h3">Click Traffic</Popover.Header>
            <Popover.Body>
                {
                    !urls?.length ? (
                        <Row className='text-start py-1' style={ { fontSize: '12px' } }>
                            <Col>No clicks</Col>
                        </Row>
                    ) : (
                        urls?.map( ( [ u, c ], idx ) => {
                            return (
                                <Row key={`${u}-${idx}`} className='text-start py-1' style={ { fontSize: '12px' } }>
                                    <Col className='pe-1 fw-bold text-truncate'><a href={u} target="_blank" rel="noopener noreferrer">{u}</a></Col>
                                    <Col xs='auto' className='ps-5'>{c}</Col>
                                </Row>
                            )
                        } ) 
                    )
                }
            </Popover.Body>
        </Popover>
    );

    useEffect( () => {
        if ( links ) {
            console.log( links );
            const sites = Object.entries( links ).sort( ( [, countA], [, countB] ) => countB - countA );
            console.log( sites );
            setUrls( sites );
        }
    }, [ links ] );

    return (
        <Container>
            <Row className='p-0'>
                <Col xs='auto' className='p-0 pe-2'>
                {
                    <OverlayTrigger placement="right" overlay={popup} show={show} container={ref}>
                        <Col xs='auto' ref={ref} onMouseEnter={handleOnMouseEnter} onMouseLeave={handleOnMouseLeave}><Button variant='link' size='sm'>{count}</Button></Col>
                    </OverlayTrigger> 
                }
                </Col>
            </Row>
        </Container>
    )
}

const mapProps = ( state ) => ( {
    contacts: state.contacts.byId,
} );
  
const mapDispatch = ( dispatch ) => ( {
} );
  
export default connect( mapProps, mapDispatch )( ClicksInGrid );